import React from 'react';
import { motion } from 'framer-motion';

const AffiliateDisclosure = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <div className="pt-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <motion.div {...fadeInUp}>
          <h1 className="text-4xl font-bold text-[#0B1320] font-poppins mb-8">
            Affiliate Disclosure
          </h1>
          <div className="prose prose-lg max-w-none text-[#4A4A4A] leading-relaxed">
            <p>
              This is a placeholder for the Affiliate Disclosure page. Content will be added here.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AffiliateDisclosure;